<app-datatable [sortArray]="[{prop: 'updated', dir: 'desc'}]" 
[service]="homepageService.getPersonasOperationsDomain" 
[defaultColumns]="defaultColumns" 
[columnsToExclude]="columnsToExclude" 
[section]="'operations'" 
[subsection]="'domain'" 
[isMultiForm]="true" 
[columnsNotToFilter]="columnsNotToFilter"></app-datatable>
